import { ContentfulLogger } from 'services/Logger'

export const logBadThings = (url: string | unknown) => {
	const badThings: string[] = []
	if (url === undefined || typeof url != 'string') {
		badThings.push('URL is not a string')
	} else {
		if (url.includes('fiona.com')) badThings.push('FQDN for Fiona.com')
		if (url.includes('hifiona.com')) badThings.push('FQDN for Hifiona.com')
		if (url.includes('http://')) badThings.push('Unsecure URL')
		if (url.includes('.') && url.charAt(0) === '/') badThings.push('invalid path')
	}

	if (badThings.length > 0) {
		ContentfulLogger.info(`Shortcode created for bad URL (${url}). Issues: \n ${badThings.join('\n')}`)
	}
}

export const sanitizeUrl = (url: string) => {
	if (url.indexOf('https://') === 0) return url
	if (url.charAt(0) === '/') return url
	if (url.indexOf('learn') === 0) return `/${url}`
	else return 'https://' + url
}
